import { Navigate, Outlet } from 'react-router-dom'

import { useKeplrWallet } from '@/contexts/KeplrWalletProvider'
import { RoutePaths } from '@/routes'
import { UiSkeleton } from '@/ui/UiSkeleton'

export default function MultisigGuard() {
  const {
    address,
    isWalletConnected,
    isMultisigMember,
    isMultisigMemberLoading,
    status,
  } = useKeplrWallet()

  // Wait for wallet to finish connecting/restoring or initial check
  // Don't redirect immediately on Disconnected - give cosmos-kit time to restore
  if (status === 'Connecting' || status === 'Disconnected') {
    return (
      <div className='flex min-h-screen items-center justify-center'>
        <div className='flex flex-col items-center gap-4'>
          <UiSkeleton className='h-12 w-64' />
          <UiSkeleton className='h-8 w-48' />
        </div>
      </div>
    )
  }

  if (!isWalletConnected || !address) {
    return (
      <Navigate
        to={RoutePaths.Root}
        replace
        state={{ error: 'Please connect your wallet to access admin panel' }}
      />
    )
  }

  if (isMultisigMemberLoading) {
    return (
      <div className='flex min-h-screen items-center justify-center'>
        <div className='flex flex-col items-center gap-4'>
          <UiSkeleton className='h-12 w-64' />
          <UiSkeleton className='h-8 w-48' />
        </div>
      </div>
    )
  }

  if (!isMultisigMember) {
    return (
      <Navigate
        to={RoutePaths.Root}
        replace
        state={{ error: 'Access denied: You are not a multisig member' }}
      />
    )
  }

  return <Outlet />
}
